export const BRANCH_TYPES = [
	{
        "branchTypeId": 72,
        "branchTypeName": "Main"
    },
	{
        "branchTypeId": 73,
        "branchTypeName": "Branch"
    },
]